import { getCheckoutFormTemplate, getVueCheckoutFormTemplate } from "../../shortcodes/templates";

let checkoutForm = null;
const visualizeCheckoutForm = content => {
  checkoutForm = content.querySelectorAll('[data-tiny-mce-component="checkoutform"]')[0];
  if (checkoutForm) {
    checkoutForm.innerHTML = getCheckoutFormTemplate();
  }
};

const serializeCheckoutForm = content => {
  const checkoutWidget = content.querySelectorAll('[data-tiny-mce-component="checkoutform"]')[0];
  if (checkoutWidget) {
    // const checkoutFormData = {
    //   title: content.querySelectorAll('[data-tiny-mce-component-data="title"]')[0].innerHTML,
    //   subtitle: content.querySelectorAll('[data-tiny-mce-component-data="subtitle"]')[0].innerHTML,
    //   buttonText: content.querySelectorAll('[data-tiny-mce-component-data="buttonText"]')[0].innerHTML
    // }
    content.querySelectorAll('[data-tiny-mce-component="checkoutform"]')[0].innerHTML = getVueCheckoutFormTemplate();
  }
};

export { visualizeCheckoutForm, serializeCheckoutForm };
